// BlockingOverlay.jsx (or inline in PremiumPage file)
import { createPortal } from 'react-dom';

export default function BlockingOverlay({ text = 'Confirming your payment…' }) {
  return createPortal(
    <div
      className="fixed inset-0 z-[2147483647] bg-black/40 backdrop-blur-sm"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="bg-white rounded-xl p-5 shadow">
          <div className="h-6 w-6 border-2 border-gray-300 border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-sm text-gray-700">{text}</p>
          <p className="text-xs text-gray-500 mt-1">Please don’t refresh or close this tab.</p>
        </div>
      </div>
    </div>,
    document.body
  );
}
